import { IClickManagerInitialStateSet } from './types';
import { AT_INITIAL_STATE_SET } from './constants';

export const clickManagerInitialStateActionSet = (

): IClickManagerInitialStateSet => ({
    type: AT_INITIAL_STATE_SET
});
